import { Injectable } from '@angular/core';
import { AlertService } from './alert.service';
import { Observable, throwError } from 'rxjs';
import { enumRespErrors } from '@data-layer/enums/common';
import { enumUserRole } from '@data-layer/enums/user';
import { UserModel } from '@data-layer/models/user';
import { HttpMethod } from '@enum/http-method';
import { match } from 'path-to-regexp';
import { connector } from '@env/environment';
import { KnownErrorModel } from '@interfaces/known-error.interface';
import { knownErrors } from '@constants/known-errors.const';

@Injectable()
export class ApiErrorService {
  // if error is known - show valid predefined message
  // if error is unknown - show generic message based on role

  private user: UserModel;
  private errors: KnownErrorModel[];

  constructor(private alertService: AlertService) {
    this.errors = knownErrors();
  }

  public handleError(path: string, method: HttpMethod, err: any): Observable<any> {
    // compare existing object-map of existing url patterns with failed url&method
    // if found - show valid error from i18 file
    // see KnownErrorModel
    // & skip token alerts :)

    if (path.includes(connector)) {
      return throwError(err);
    }

    if (err?.error?.tag && this.isErrorKnown(err.error.tag)) {
      const error = this.findErroredUrl(err.error.tag, path, method);
      if (!!error && !error.isSkip) {
        this.alertService.modalError(error.errorText);
      }
    } else if (!!err?.error?.message) {
      const userRoles = this.user?.roles || [];
      const isAdminOrSupport =
        userRoles.includes(enumUserRole.SUPPORT) || userRoles.includes(enumUserRole.ADMIN) || userRoles.includes(enumUserRole.SUPER_ADMIN);
      this.alertService.error(
        isAdminOrSupport ? JSON.stringify(err?.error?.message) : null,
        isAdminOrSupport ? 'LABELS.GENERIC_API_ADMIN_ERROR' : 'LABELS.GENERIC_API_USER_ERROR',
      );
    }

    return throwError(err);
  }

  public setUser(user: UserModel): void {
    this.user = user;
  }

  private isErrorKnown(tag: string): boolean {
    return Object.values(enumRespErrors).includes(tag as enumRespErrors);
  }

  private findErroredUrl(tag: string, path: string, method: HttpMethod): KnownErrorModel {
    const filteredErrors = this.errors.filter((item) => item.tag === tag);
    let result;

    const domainToReplace = 'https://';

    for (const item of filteredErrors) {
      if (item.isGlobal) {
        result = item;
      } else {
        const fn = match(item.url.replace(domainToReplace, ''), { endsWith: '?' });

        if (item.method === method && fn(path.replace(domainToReplace, ''))) {
          result = item;
        }
      }
    }

    return result;
  }
}
